<ng-container *ngIf="downloader$ | async"></ng-container>
<ng-container *ngIf="action$ | async"></ng-container>

<div class="file-manager">
  <mat-table
    class="files-table"
    #table
    [dataSource]="dataSource"
    matSort
    matSortActive="date"
    matSortDirection="desc"
    matSortDisableClear
    fusePerfectScrollbar>
    <!-- Select Column -->
    <ng-container cdkColumnDef="select">
      <mat-header-cell *cdkHeaderCellDef class="max-w-16">
        <mat-checkbox
          [ngModel]="selectedAll"
          [disabled]="!editableOrder || orderModelsService.onCadModelsChanged.value.length === 0"
          (change)="selectAll()"></mat-checkbox>
      </mat-header-cell>
      <mat-cell *cdkCellDef="let item" class="max-w-16">
        <mat-checkbox
          [disabled]="!editableOrder"
          (click)="$event.stopPropagation()"
          (change)="$event ? selectedOrderFiles.toggle(item.id) : null"
          [checked]="selectedOrderFiles.isSelected(item.id)"></mat-checkbox
      ></mat-cell>
    </ng-container>

    <!-- Name Column -->
    <ng-container cdkColumnDef="name">
      <mat-header-cell i18n *cdkHeaderCellDef>Название</mat-header-cell>
      <mat-cell *cdkCellDef="let item" class="hidden md:flex">
        <p class="text-truncate">{{ item.filename }}</p>
      </mat-cell>
    </ng-container>

    <!-- Sign Column -->
    <ng-container cdkColumnDef="sign">
      <mat-header-cell i18n *cdkHeaderCellDef>Обозначение</mat-header-cell>
      <mat-cell *cdkCellDef="let item" class="hidden md:flex">
        <p class="text-truncate">{{ item.sign }}</p>
      </mat-cell>
    </ng-container>

    <!-- Count Column -->
    <ng-container matColumnDef="count">
      <mat-header-cell i18n *matHeaderCellDef>Количество</mat-header-cell>
      <mat-cell *matCellDef="let item">
        <p class="text-truncate">{{ item.count }}</p>
      </mat-cell>
    </ng-container>

    <!-- Materials Column -->
    <ng-container matColumnDef="materials">
      <mat-header-cell i18n *matHeaderCellDef>Материалы</mat-header-cell>
      <mat-cell *matCellDef="let item">
        <div *ngIf="isUploading(item)" class="flex flex-row space-x-2 items-center">
          <mat-spinner [diameter]="20"></mat-spinner>
          <div i18n class="text-bold">Загрузка</div>
        </div>

        <div *ngIf="isConverting(item)" class="flex flex-row space-x-2 items-center">
          <mat-spinner [diameter]="20"></mat-spinner>
          <div i18n class="text-bold">Конвертирование</div>
        </div>

        <div *ngIf="isMaterialLinking(item)" class="flex flex-row space-x-2 items-center">
          <mat-spinner [diameter]="20"></mat-spinner>
          <div i18n class="text-bold">Замена материалов</div>
        </div>

        <div *ngIf="isMaterialParsing(item)" class="flex flex-row space-x-2 items-center">
          <mat-spinner [diameter]="20"></mat-spinner>
          <div i18n class="text-bold">Чтение модели</div>
        </div>

        <button
          i18n
          mat-raised-button
          color="accent"
          (click)="openSemifinishedProductDialog(item)"
          *ngIf="isSemifinishedProductTypeSetting(item)"
          >Назначить тип полуфабрикатов</button
        >

        <button i18n mat-raised-button color="accent" (click)="openLinkModelMaterials()" *ngIf="canLinkMaterial(item)"
          >Сопоставить</button
        >

        <button *ngIf="canShowLinkedMaterials(item)" mat-raised-button color="accent" [matMenuTriggerFor]="viewMenu">
          Просмотр
        </button>

        <mat-menu #viewMenu="matMenu">
          <button i18n mat-menu-item (click)="openGlanceLinkModelMaterials(item)">Сопоставленные материалы</button>
          <button i18n mat-menu-item *ngIf="canShowLinkedMaterials(item)" (click)="openListModelMaterials(item)"
            >Список деталей</button
          >
        </mat-menu>
      </mat-cell>
    </ng-container>

    <!-- Size Column -->
    <ng-container cdkColumnDef="size">
      <mat-header-cell i18n *cdkHeaderCellDef>Размер</mat-header-cell>
      <mat-cell *cdkCellDef="let item" class="hidden md:flex">
        <p class="text-truncate">
          {{ item.fileSize | fileSize }}
        </p>
      </mat-cell>
    </ng-container>

    <!-- Date Column -->
    <ng-container cdkColumnDef="date">
      <mat-header-cell i18n *cdkHeaderCellDef>Дата</mat-header-cell>
      <mat-cell *cdkCellDef="let item" class="hidden md:flex">
        <p class="text-truncate">
          {{ item.dateUpload | date : 'shortDate' }}
        </p>
      </mat-cell>
    </ng-container>

    <!-- State Column -->
    <ng-container cdkColumnDef="state">
      <mat-header-cell i18n *cdkHeaderCellDef>Статус</mat-header-cell>
      <mat-cell *cdkCellDef="let item" class="hidden md:flex">
        <p class="text-truncate">
          {{ getModelState(item.state) }}
        </p>
      </mat-cell>
    </ng-container>

    <!-- Menu Column -->
    <ng-container matColumnDef="menu">
      <mat-header-cell *matHeaderCellDef>
        <button mat-icon-button [matMenuTriggerFor]="delete"><mat-icon>more_vert</mat-icon></button>
        <mat-menu #delete="matMenu">
          <button mat-menu-item i18n (click)="deleteOrderFiles()" [disabled]="selectedOrderFiles.selected.length === 0"
            >Удалить выбранные модели</button
          >
        </mat-menu>
      </mat-header-cell>
      <mat-cell *matCellDef="let item">
        <input
          hidden
          type="file"
          #modelFileInput
          accept="{{ allowedModelExt.join(', ') }}"
          (change)="replaceModel($any($event), item)" />
        <button mat-icon-button *ngIf="isDraftOrder()" [matMenuTriggerFor]="menu">
          <mat-icon class="mat-24" aria-label="">more_vert</mat-icon>
        </button>
        <mat-menu #menu="matMenu">
          <button i18n mat-menu-item (click)="openLinkModelMaterials(item)">Изменить сопоставленный материал</button>
          <button i18n mat-menu-item (click)="modelFileInput.click()" *ngIf="editableOrder || isUploading(item)"
            >Заменить модель</button
          >
        </mat-menu>
      </mat-cell>
    </ng-container>

    <!-- Edit Column -->
    <ng-container matColumnDef="edit">
      <mat-header-cell *matHeaderCellDef></mat-header-cell>
      <mat-cell *matCellDef="let item">
        <button
          i18n-matTooltip
          [disabled]="!editableOrder || isUploading(item)"
          mat-icon-button
          (click)="openDetailOrderFile(item)"
          matTooltip="Изменить">
          <mat-icon class="mat-24" aria-label="">edit</mat-icon>
        </button>
      </mat-cell>
    </ng-container>

    <!-- Download Column -->
    <ng-container matColumnDef="download">
      <mat-header-cell *matHeaderCellDef></mat-header-cell>
      <mat-cell *matCellDef="let item">
        <button
          i18n-matTooltip
          [disabled]="isUploading(item) || (item.isUnlicensed && !item.isPaid)"
          mat-icon-button
          (click)="downloadOrderFile(item)"
          matTooltip="Скачать модель">
          <mat-icon class="mat-24" aria-label="">get_app</mat-icon>
        </button>
      </mat-cell>
    </ng-container>

    <!-- Delete Column -->
    <ng-container matColumnDef="delete">
      <mat-header-cell *matHeaderCellDef></mat-header-cell>
      <mat-cell *matCellDef="let item">
        <ng-container *ngIf="!deletingCadModels.has(item); else deleteSpinner">
          <button
            i18n-matTooltip
            [disabled]="!editableOrder || isUploading(item)"
            mat-icon-button
            (click)="deleteOrderFile(item)"
            matTooltip="Удалить">
            <mat-icon class="mat-24" aria-label="">delete</mat-icon>
          </button>
        </ng-container>
        <ng-template #deleteSpinner>
          <mat-spinner [diameter]="20" i18n-matTooltip matTooltip="Выполняется удаление"></mat-spinner>
        </ng-template>
      </mat-cell>
    </ng-container>

    <mat-header-row *cdkHeaderRowDef="displayedColumns"></mat-header-row>

    <mat-row *cdkRowDef="let item; columns: displayedColumns" class="file"></mat-row>
  </mat-table>
</div>
